"use client";
import { Providers } from "@/lib/redux/provider";
import "./globals.css";
import { Inter } from "next/font/google";
import { useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { Suspense } from "react";

const inter = Inter({ subsets: ["latin"] });

// export const metadata = {
//   title: "Festive Offer",
//   description: 'Boilerplate nextjs+bootstrap',
// };

export default function RootLayout({ children }) {
  // useEffect(()=> {
  // if (typeof window !== 'undefined') {
  //   require('bootstrap/dist/js/bootstrap.min.js');
  // }
  // });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  let img = "";

  useEffect(() => {
    if (isMobile) {
      img = `url("/images/img_background_mobile.png"),#174035`;
    } else {
      img = `url("/images/background_img.png"),#174035')`;
    }
  }, []);

  const getBodyStyle = () => ({
    backgroundImage: isMobile
      ? 'url("/images/img_background_mobile.png")'
      : 'url("/images/background_img.png")',
    backgroundColor: "#174035",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: "100vh",
    // width: '100%',
  });

  return (
    <html lang="en">
      <head>
        <link rel="shortcut icon" href="/images/favicon.png" />
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </head>
      <body className={inter.className}>
        <div style={getBodyStyle()}>
          <Suspense>
            <Providers>{children}</Providers>
          </Suspense>
        </div>
      </body>
    </html>
  );
}
